import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { Button, Dialog } from "@mui/material";
import "./MergeTicketDialog.css";
import "../Components/Components.css";
import { setSocketNotification } from "../Store/Actions/CallAction";
import { mergeTicket } from "../Store/Actions/TicketAction";
import { TICKET_MERGED } from "../Store/Types/SocketTypes";

const MergeTicketDialog = ({
  isOpen,
  setIsMergeTicketDialogShown,
  setTicketMergeDestination,
  setTicketMergeSource,
  ticketMergeDestination,
  ticketMergeSource,
}) => {
  const { myInfo } = useSelector((state) => state.auth);

  const handleClose = () => {
    setTicketMergeSource(null);
    setTicketMergeDestination(null);
    setIsMergeTicketDialogShown(false);
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog merge-ticket-dialog"
      fullWidth
      maxWidth="sm"
      scroll="paper"
      onClose={handleClose}
    >
      <header>
        <Icon height="28" icon="ion:warning" width="28" />
        <p>Warning!</p>
        <Icon height="28" icon="ion:warning" width="28" />
      </header>

      <div className="dialog-content">
        <p>
          <span>TicketNo-{ticketMergeSource?.TicketNo}</span> will be merged
          into <span>TicketNo-{ticketMergeDestination?.TicketNo}</span>
        </p>

        <p>Do you wish to continue?</p>

        <div className="buttons">
          <Button
            className="cancel"
            variant="outlined"
            onClick={() => setIsMergeTicketDialogShown(false)}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={() => {
              mergeTicket({
                parentcaseid: ticketMergeSource.CaseID,
                caseid: ticketMergeDestination.CaseID,
              })
                .then((response) => {
                  if (response.status) {
                    toast.success("Ticket Merge Success", { autoClose: 5000 });

                    // Send notification to leader
                    setSocketNotification({
                      EventName: TICKET_MERGED,
                      EventType: "INFO", // WARNING || INFO || ERROR
                      Message: `${myInfo.user.AgentName} has merged a ticket!`,
                      RefNo: ticketMergeSource.caseID,

                      NotifyAgents: [
                        {
                          AgentID: myInfo.user.LeaderID,
                        },
                      ],
                    })
                      .then((response) => {
                        if (response.status) {
                          console.log(
                            `Notification sent to ${myInfo.user.LeaderName}`
                          );
                        } else {
                          console.log("error", response.error);
                        }
                      })
                      .catch((err) => {
                        console.log("err", err);
                      });

                    handleClose();
                  } else {
                    console.log("error", response.error);
                    toast.error("Error Merge Ticket", { autoClose: 5000 });
                  }
                })
                .catch((err) => {
                  console.log("err", err);
                  toast.error("Error Merge Ticket", { autoClose: 5000 });
                });
            }}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default MergeTicketDialog;
